import React from 'react';
import useAreaMap from '../../hooks/useAreaMap';

// passing lifted state and its change handler in as function args
export default function AreaMap({
  stateSchema,
  handleLocationIDsChange,
  operationalStates
}) {
  const { areaMap, handleMapStyleChange, toggleableLayers } = useAreaMap({
    stateSchema,
    handleLocationIDsChange,
    operationalStates
  });

  return (
    <>
      <div>
        <span className='layer-button-Legend'>Basemap: </span>
        {['light-v10', 'dark-v10', 'streets-v11', 'satellite-v9'].map(
          (item) => {
            return (
              <button
                className='basemap-layer-button'
                key={item}
                id={item}
                onClick={() => handleMapStyleChange(item)}
              >
                {item.split('-')[0]}
              </button>
            );
          }
        )}

        {toggleableLayers && (
          <div>
            <span className='layer-button-Legend'>Layers: </span>
            {toggleableLayers}
          </div>
        )}
      </div>
      <div className='area-map-container' id='menu' ref={areaMap}></div>
    </>
  );
}
